import { ROUTES } from '@/constants';
import store from '@/store';
import i18n from '@/library/i18n';

export default [
  {
    path: '/template',
    name: ROUTES.TEMPLATE,
    component: () => import(/* webpackChunkName: "template" */ "@/pages/template/Template.vue"),
    meta: {
      title: "Template Overview Page"
    }
  },
  {
    path: '/',
    name: ROUTES.ORDERFORM,
    component: () => import(/* webpackChunkName: "order-form" */ "@/pages/orderForm/OrderForm.vue"),
    meta: {

      beforeResolve: async (to, from, next) => {
        const breadcrumbs = [
          {
            text: 'Home',
            to: `/`
          },
          {
            text: 'OrderForm',
            disabled: true,
          },
        ];
        await store.dispatch('app/setBreadcrumbs', breadcrumbs);

        const currentLang = store.getters['settings/lang'];
        i18n.locale = currentLang.toLowerCase() || 'ua';
        document.title = i18n.t('meta.title');


        const descriptionMetaTag = document.querySelector('meta[name="description"]');
        if (descriptionMetaTag) {
          descriptionMetaTag.setAttribute('content', i18n.t('meta.description'));
        }

        return next();
      }
    },
  },
];
